import React from 'react';
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import Utils from "../../common/Utils";
import AppVariables from "../../common/AppVariables";
import {Gender} from "../../common/Constants";
import {CustomFilterFrame} from "../../components/CRUDView";
import {Button, Col, Row} from "reactstrap";
import ClearButton from "../../components/CRUDView/Components/ClearButton";
import {Async as AsyncSelect, components} from "react-select";
import TwoLineItemRender from "../../components/Elements/TwoLineItemRender";
import {TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import _ from "lodash";
import TTLProxy from "../../common/TTLAsyncProxy";

export const LicenseClasses = ['A','B','C','D','E','F'];

export const OPERATORS_QUERY_FILTERS = [
    {
        key: 'sex',
        query: "gender",
        name: "Gender",
        apply: true,
        fromQuery: value => {

            if(isFinite(value))
                return Number(value);

            if(value){
                switch (value.toLowerCase()) {
                    case "male":
                        return Gender.Male;
                    case "female":
                        return  Gender.Female;
                }
            }

        },
        renderValue: value => {

            switch (value) {
                case Gender.Male:
                    return "Male";
                case Gender.Female:
                    return  "Female";
            }
        }
    },
    {
        key: "name",
        query: "name",
        operator: "[]",
        apply: true
    },
    {
        key: "phone",
        query: "phone",
        operator: "[]",
        apply: true
    },
    {
        key: "email",
        query: "email",
        operator: "[]",
        apply: true
    },
    {
        key: "address",
        query: "address",
        operator: "[]",
        apply: true
    },
    {
        key: "license",
        query: "license",
        operator: "[]",
        apply: true,
        fromQuery: value => LicenseClasses.includes(value) ? value : undefined
    },
    {
        key: "owner.id",
        query: "owner_id",
        apply: true
    },
    {
        key: "tractorOwnerName",
        query: "_owner_select_name"
    }
];

export const parseOperatorsQueryFilters = (filters) => {

    const getSelectOption = (entity,queryKey,filterKey) => {
        const _key = filterKey || `${entity}.id`;
        const _name = filters[queryKey || `${entity}Name`];
        return filters[_key] ? { label: _name , value: filters[_key]  , instance: { id : filters[_key] , name: _name } } : null ;
    };

    return {
        name: filters.name || '',
        phone: filters.phone || '',
        address: filters.address || '',
        email: filters.email || '',
        license: filters.license || '',
        owner: getSelectOption('owner','tractorOwnerName')
    };
};

export const OperatorsCustomFilterView = ({ applyFilters, toggle , values , setValue , setValues , resetValues , includeOwner = true }) => {

    const proxy = TTLProxy.getInstance();

    return <CustomFilterFrame toggle={toggle}>

        <Row className="mb-1">
            <Col md={3}>

                <b>Name</b>
                <input name="name"
                       value={values['name']}
                       onChange={evt => {
                           setValue('name',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Operator name"/>

            </Col>

            <Col md={3}>

                <b>Phone</b>
                <input name="phone"
                       value={values['phone']}
                       onChange={evt => {
                           setValue('phone',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Operator phone number"/>

            </Col>

            <Col md={3}>

                <b>Email</b>
                <input name="email"
                       value={values['email']}
                       onChange={evt => {
                           setValue('email',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Operator email"/>

            </Col>


            <Col md={3}>

                <b>License</b>
                <select className="form-control form-input-select" value={values['license']} onChange={evt =>{
                    setValue('license',evt.target.value);
                }}>
                    <option value={""}>None</option>
                    {LicenseClasses.map((c,k) => (<option key={k}>{c}</option>))}
                </select>



            </Col>
        </Row>

        <Row className="mb-1">
            <Col md={3}>

                <b>Address</b>
                <input name="address"
                       value={values['address']}
                       onChange={evt => {
                           setValue('address',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Operator's address"/>

            </Col>

            {includeOwner && <Col md={3}>

                <div className="clearfix">
                    <b className="pull-left">Tractor Owner</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            owner: null,
                            tractorOwnerName: null
                        })}/>
                    </div>
                </div>

                <AsyncSelect  name="owner"
                              defaultOptions
                              cacheOptions
                              placeholder="Select tractor owner..."
                              value={values['owner']}
                              onChange={value => {
                                  setValue('owner',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const owner = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={owner.media}
                                                              line1Value={owner.name}
                                                              line2Prefix="Phone"
                                                              line2Value={owner.user.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const res = await proxy.processRequest(TractorOwnerEndpoints.getUrl(), {
                                          search: { keyword: value , method: 'inside', fields: ['name' , 'user.email', 'user.phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      });

                                      return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>

            </Col>}

        </Row>

        <hr/>

        <div className="clearfix">

            <div className="pull-left">
                <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
            </div>

            <div className="pull-right">
                <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                    let _targetFilter = { };
                    Object.keys(values).forEach(k => {

                        let _v = values[k];
                        let _initialValue = _v;

                        switch (k) {
                            case "owner":
                                k = "owner.id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorOwnerName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                        }

                        if(!_.isNil(_v) && _v !== ""){
                            _targetFilter[k] = _v;
                        }
                        else{
                            _targetFilter[k] = undefined;
                        }

                    });

                    applyFilters(_targetFilter);


                }}><i className="fa fa-check"/> Apply</Button>
            </div>
        </div>

    </CustomFilterFrame>
};

/**
 * Gets the inputs for rendering tractor operator registration form
 */
function getInputs(opts) {

    const formRenderer = opts['formRenderer'];

    return [
        { name : 'name' , title: 'Name' , hint : `Enter operator name here eg eg ${AppVariables.NameExample}` , type: 'text' , icon : 'fa fa-user' , required: true },
        { name : 'phone' , title: 'Phone Number' , hint : `Enter phone number eg ${AppVariables.PhoneNumberExample}` , type: 'phone' , icon : 'fa fa-phone' , required: true },
        {
            group: [
                {
                    name : 'license' , title: 'License class' , hint : 'Select operator license class here...' , type: 'dropdown' , required: true ,
                    items: LicenseClasses.map(c =>{
                        return { name: c, text: c, value: c };
                    }),
                    multi: true ,
                    simple: true
                }
            ],
            render: (content,key) => {

                return (<div key={key}>
                    <DialogCollapseSection title="License" initiallyOpen={true} >
                        {content}
                    </DialogCollapseSection>
                    <hr/>
                </div>);
            }
        },

        { name : 'address' , title: 'Address' , hint : 'Enter operator address here' , type: 'location' , icon : 'fa fa-map-marker' , coord: {
            lat: 'address_lat',
            lng: 'address_long'
        }},
        { name : 'sex'  , title: 'Gender' , hint: 'Select farmer gender' , type: 'select' , format: 'number' , icon : 'fa fa-user' , items: [
            { value : Gender.Male , text: 'Male' },
            { value : Gender.Female , text: 'Female'}
        ]},
        { name:  'owner' , title: 'Owner' , type: 'select', format: 'number' , icon: 'fa fa-user' ,

            setValue: (input,item) => {

                let renderer = formRenderer();
                let value = item.owner ? item.owner.id : (opts.owners.length > 0 ? opts.owners[0].id:  null);
                if(value){

                    //
                    input.value = value;

                    //  get operator tractors
                    opts.fetchOwnerTractors(value,true , undefined , item.tractor ? [item.tractor.id] : undefined).then(() => {

                        //  refresh tractor
                        renderer.refreshInput('tractor',item);

                    });
                }

            },

            refresh: () => {
                return opts.refreshTractorOwners();
            },

            //  return items
            items: () => ( opts.owners || [] ).map((o) => {
                return { value: o.id , text: o.user.phone ? `${o.name} (${o.user.phone})` : o.name }
            }),

            //  on changed
            onChange: (id) => {
                const owner =  opts.editItem;
                opts.fetchOwnerTractors(id,true,undefined,owner && owner.tractor ? [owner.tractor.id] : undefined );
                formRenderer().removeInputError('tractor');
            }
        },
        {
            group: [
                {
                    name:  'tractor' , title: 'Tractor' , type:'select' , icon : 'tractor',
                    comment: <p>Assign a tractor to the operator by selecting it below. An operator can be added without a tractor</p>,

                    refresh: () => {
                        formRenderer().findInput('owner').refresh();
                    },

                    setValue: (input,item) => {
                        input.value = item.tractor ? item.tractor.id :  '';
                    },

                    items: () => {
                        const tractors = opts.tractors || [];
                        return Utils.insertNone(tractors.map((t) => { return { value: t.id , text : Utils.formatTractorName(t) } }));
                    }
                }
            ],
            render: (content,k) => {

                return (<div key={k}>
                    <hr/>
                    <DialogCollapseSection title={"Optional"}  onExpand={() => {

                        let renderer = formRenderer();
                        const id = renderer.getInputValueWithName("owner") || (opts.owners[0].id);

                        //  Load Tractors
                        if(id !== undefined) {
                            const owner = opts.owners.find(x => x.id == id);
                            if(owner) {
                                opts.fetchOwnerTractors(owner.id, true, undefined, owner && owner.tractor ? [owner.tractor.id] : undefined);
                            }
                        }

                    }}>
                        {content}
                    </DialogCollapseSection>
                </div>);

            }
        }

    ]
}

export {
    getInputs
}



// WEBPACK FOOTER //
// ./src/views/Operators/OperatorCommon.js